import { ReactComponent as BadgeIcon } from 'assets/svg/badge.svg'
import { ReactComponent as BoardIcon } from 'assets/svg/board.svg'
import { ReactComponent as UserIcon } from 'assets/svg/user.svg'
import { ReactComponent as StarIcon } from 'assets/svg/star.svg'

const statisticsList = [
  {
    id: 1,
    title: '4.93 / 5',
    subtitle: 'Enjoyment Score',
    isSwgPath: true,
    Icon: <StarIcon />,
    text: '87% of respondents gave the top score Consistently high with even more “definitely will be a speaker” responses.',
  },
  {
    id: 3,
    title: '11 Sessions',
    subtitle: '3 Hands-on Workshop Labs Held',
    Icon: <BoardIcon />,
    text: 'We offered a mix of AWS technical and non-technical sessions, including leadership talks and hands-on labs.',
  },
  {
    id: 2,
    title: '440+',
    subtitle: 'On-Site Participants',
    Icon: <UserIcon />,
    text: 'We grew the crowd and were excited to see so many tech enthusiasts and experts joined us for a packed day of learning, networking and fun!',
  },
  {
    id: 4,
    title: '32+',
    subtitle: 'Future Speakers Count',
    Icon: <BadgeIcon />,
    text: 'Over 32 inspired individuals, motivated by the energy of AWS Community Day Armenia 2025, are ready to share their knowledge as speakers or hands-on lab leaders at our future events!',
  },
]

export default statisticsList
